export const COMPANY = {
  name: "M&A Objektservice",
  legalName: "M&A Objektservice GbR",
  owners: "Mahmoud Alhaj Abdo & Timon Malms",
  address: "Alte Hofstraße 23a, 63584 Gelnhausen",
  phone: "+49 1523 4623497",
  phoneRaw: "+4915234623497",
  email: "info@maobjektservice.de",
  area: "Gelnhausen + 50 km Umkreis",
  hours: "Mo–Sa 8:00–20:00 Uhr",
  slogan: "Zuverlässig · Sauber · Professionell",
  whatsapp: "https://wa.me/4915234623497",
  instagram: "https://www.instagram.com/maobjektservice?igsh=N2tzOTRnbWh6eWs5",
  tiktok: "https://www.tiktok.com/@maobjektservice?_r=1&_t=ZG-98exmXDxUkj",
};

export const LOGO_URL = "https://customer-assets-wrfwihn1.emergentagent.net/job_ma-objektservice/artifacts/5q9gav9h_objektservice%202.jpeg";

export const SERVICES = [
  {
    slug: "hausmeisterservice",
    icon: "Wrench",
    title: "Hausmeisterservice",
    tagline: "Ihr Objekt in besten Händen",
    desc: "Zuverlässige Betreuung rund um Ihr Gebäude – regelmäßig und gewissenhaft.",
    items: ["Treppenhausreinigung", "Kehrdienst", "Mülltonnen-Service", "Kleinreparaturen", "Glühbirnen wechseln", "Schlösser & Türgriffe"],
    image: "https://images.unsplash.com/photo-1670589953882-b94c9cb380f5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "reinigungsarbeiten",
    icon: "Sparkles",
    title: "Reinigungsarbeiten",
    tagline: "Glanz bis ins Detail",
    desc: "Professionelle Reinigung für innen und außen – strahlende Ergebnisse.",
    items: ["Fensterreinigung", "Wintergarten & Terrasse", "Hof & Hochdruck", "Solaranlagen", "Fassade & Graffiti", "Baustelle & Dachrinne"],
    image: "https://images.unsplash.com/photo-1740657254989-42fe9c3b8cce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "gartenpflege",
    icon: "Leaf",
    title: "Gartenpflege",
    tagline: "Grün, gepflegt, einladend",
    desc: "Wir halten Ihre Außenanlagen das ganze Jahr in perfekter Form.",
    items: ["Rasen mähen", "Hecken schneiden", "Unkraut entfernen", "Laub beseitigen", "Sträucher pflegen", "Beete anlegen"],
    image: "https://images.unsplash.com/photo-1624190011779-081f7cd23eae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "winterdienst",
    icon: "Snowflake",
    title: "Winterdienst",
    tagline: "Sicher durch den Winter",
    desc: "Zuverlässiges Räumen und Streuen – für sichere Wege bei jedem Wetter.",
    items: ["Schnee räumen", "Streuen", "Gehwege sichern", "Verkehrssicherungspflicht", "Früh & pünktlich", "Auf Abruf"],
    image: "https://images.unsplash.com/photo-1769605767937-2406841fe405?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "entruempelung",
    icon: "PackageOpen",
    title: "Entrümpelung & Wohnungsauflösung",
    tagline: "Besenrein & stressfrei",
    desc: "Von Keller bis Dachboden – wir räumen, entsorgen und übergeben besenrein.",
    items: ["Keller & Dachboden", "Garage", "Komplette Wohnung", "Büroauflösung", "Fachgerechte Entsorgung", "Besenreine Übergabe"],
    image: "https://images.unsplash.com/photo-1600585152220-90363fe7e115?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "umzugsservice",
    icon: "Truck",
    title: "Umzugsservice",
    tagline: "Ankommen ohne Sorgen",
    desc: "Wir packen an – vom Verpacken bis zum Aufbau am neuen Zuhause.",
    items: ["Tragen & Transport", "Verpacken", "Möbel auf-/abbauen", "Umzugshilfe", "Sorgfältig & versichert", "Flexibel planbar"],
    image: "https://images.unsplash.com/photo-1600518464441-9154a4dea21b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "montageservice",
    icon: "Hammer",
    title: "Montageservice",
    tagline: "Fachgerecht montiert",
    desc: "Möbel, Regale und mehr – sauber und sicher aufgebaut.",
    items: ["Möbelmontage", "Regale", "Lampen (ohne Elektro)", "Gardinenstangen", "Bilder & Spiegel", "Kleinmontagen"],
    image: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "objektbetreuung",
    icon: "KeyRound",
    title: "Objektbetreuung",
    tagline: "Immer ein Auge auf Ihr Objekt",
    desc: "Zuverlässige Kontrolle und Betreuung – auch bei Leerstand.",
    items: ["Kontrollgänge", "Leerstandsbetreuung", "Schlüsselservice", "Schadensmeldung", "Mieterkontakt", "Regelmäßige Berichte"],
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "firmenservice",
    icon: "Building2",
    title: "Firmenservice",
    tagline: "Für einen professionellen Auftritt",
    desc: "Gewerbliche Betreuung für Büros, Lager und Außenanlagen.",
    items: ["Büroreinigung", "Lagerpflege", "Außenanlagen", "Kleintransporte", "Regelmäßige Verträge", "Individuelle Lösungen"],
    image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "airbnb-service",
    icon: "BedDouble",
    title: "Airbnb & Ferienwohnungsservice",
    tagline: "Gäste-ready, jederzeit",
    desc: "Komplettbetreuung Ihrer Ferienwohnung zwischen den Buchungen.",
    items: ["Wäscheservice", "Reinigung nach Check-out", "Ausstattung prüfen", "Schlüsselübergabe", "Kleinreparaturen", "Gästebetreuung"],
    image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const TRUST_BADGES = [
  { icon: "Search", label: "Kostenlose Besichtigung" },
  { icon: "BadgeEuro", label: "Faire Preise" },
  { icon: "MessageCircle", label: "Per WhatsApp erreichbar" },
  { icon: "CalendarClock", label: "Schnelle Termine" },
];

export const TARGET_GROUPS = [
  { icon: "Home", label: "Privatpersonen", desc: "Haus- & Wohnungseigentümer" },
  { icon: "Building", label: "Vermieter & Verwaltungen", desc: "Effiziente Objektbetreuung" },
  { icon: "Users", label: "Eigentümergemeinschaften", desc: "WEG-Betreuung" },
  { icon: "Factory", label: "Gewerbebetriebe", desc: "Zuverlässiger Partner" },
  { icon: "Handshake", label: "Makler", desc: "Für die Vermarktung" },
  { icon: "HeartHandshake", label: "Senioren", desc: "Verlässliche Unterstützung" },
];

export const PROMISES = [
  { no: "01", title: "Zuverlässigkeit", text: "Wir kommen pünktlich, halten Absprachen ein und sind erreichbar, wenn Sie uns brauchen." },
  { no: "02", title: "Sauberkeit", text: "Sorgfalt bis ins Detail. Wir hinterlassen jedes Objekt so, wie wir es selbst vorfinden möchten." },
  { no: "03", title: "Professionalität", text: "Faire Preise, transparente Kommunikation und Ergebnisse, die überzeugen." },
];
